export enum AuthMethod {
  email = 'email',
  sms = 'sms'
}
